const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-3.5 0a3.5 3.5 0 1 0-7 0 3.5 3.5 0 1 0 7 0" clip-rule="evenodd"/></svg>';
export {
  e as w
};
